import gql from 'graphql-tag';

const destinationMessageFragments = {
    DestinationMessage: gql`
        fragment DestinationMessageDestinationMessage on DestinationMessage {
            iconText {
                message
                icon
                messageValueType
            }
        }
    `,
};

export default destinationMessageFragments;
